var _defs, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 141,
    viewBox: "0 0 96 141",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad",
    x1: 0,
    y1: 70.13,
    x2: 95.5,
    y2: 70.13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4356F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994DF7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "revealClip"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "clipRect",
    x: -10,
    y: -10,
    width: 116,
    height: 0
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "height",
    from: 0,
    to: 161,
    dur: "0.7s",
    begin: "1.5s",
    fill: "freeze",
    calcMode: "spline",
    keySplines: "0.4 0 0.2 1"
  }))), /*#__PURE__*/React.createElement("style", null, "\n      .stroke-path {\n        fill: none;\n        stroke: url(#grad);\n        stroke-width: 2;\n        stroke-dasharray: 1200;\n        stroke-dashoffset: 1200;\n        animation: drawStroke 1.2s cubic-bezier(0.4, 0, 0.2, 1) forwards 0.3s;\n      }\n      @keyframes drawStroke {\n        to { stroke-dashoffset: 0; }\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "stroke-path",
    d: "M95.5 13.57C95.5 8.47 92.6 3.77 88 1.47C83.4 -0.829999 78 -0.429999 73.8 2.67C73.8 2.67 12.3 49.17 9.1 51.67C3.3 56.17 0 62.87 0 70.17C0 77.47 3.3 84.27 9.1 88.67C12.3 91.17 73.8 137.57 73.8 137.57C76.2 139.37 79 140.27 81.9 140.27C84 140.27 86.1 139.77 88 138.77C92.6 136.47 95.5 131.77 95.5 126.67V93.37C95.5 88.97 93.4 84.77 89.9 82.17L73.8 70.17L89.9 58.17C93.4 55.57 95.5 51.37 95.5 46.97V13.57ZM81.5 46.87L32.8 83.07L44.3 91.97L62 78.87L81.5 93.37V125.97L47.8 100.97L47.6 100.77L40.1 95.17L40.2 95.07L28.7 86.27H28.6C27.7 85.57 26.7 84.77 25.4 83.77L25.2 83.57C23.2 81.97 20.6 79.97 17.6 77.67C15.3 75.87 13.9 73.17 13.9 70.17C13.9 67.17 15.2 64.47 17.6 62.67C22.4 58.97 26.1 56.07 28.6 53.97L46.4 67.17L58.3 58.67L40 45.07L81.4 14.27L81.5 46.87Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#grad)",
    clipPath: "url(#revealClip)",
    d: "M95.5 13.57C95.5 8.47 92.6 3.77 88 1.47C83.4 -0.829999 78 -0.429999 73.8 2.67C73.8 2.67 12.3 49.17 9.1 51.67C3.3 56.17 0 62.87 0 70.17C0 77.47 3.3 84.27 9.1 88.67C12.3 91.17 73.8 137.57 73.8 137.57C76.2 139.37 79 140.27 81.9 140.27C84 140.27 86.1 139.77 88 138.77C92.6 136.47 95.5 131.77 95.5 126.67V93.37C95.5 88.97 93.4 84.77 89.9 82.17L73.8 70.17L89.9 58.17C93.4 55.57 95.5 51.37 95.5 46.97V13.57ZM81.5 46.87L32.8 83.07L44.3 91.97L62 78.87L81.5 93.37V125.97L47.8 100.97L47.6 100.77L40.1 95.17L40.2 95.07L28.7 86.27H28.6C27.7 85.57 26.7 84.77 25.4 83.77L25.2 83.57C23.2 81.97 20.6 79.97 17.6 77.67C15.3 75.87 13.9 73.17 13.9 70.17C13.9 67.17 15.2 64.47 17.6 62.67C22.4 58.97 26.1 56.07 28.6 53.97L46.4 67.17L58.3 58.67L40 45.07L81.4 14.27L81.5 46.87Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.092682dd2a26a4d985f0608a6ec84dc1.svg";
export { ForwardRef as ReactComponent };